<template>
  <div class="info" :class="{ '-simple': simple }" v-if="item.text">
    <div class="u-containar">
      <p class="info_heading">{{ heading }}</p>
      <component
        class="info_contents"
        :is="item.url ? 'a' : 'p'"
        :href="item.url ? item.url : ''"
        :target="item.blank ? '_blank' : ''"
      >
        {{ item.text }}
      </component>
    </div>
  </div>
</template>

<script lang="ts">
// import { reactive } from 'vue'
// import { axiosSetting } from '@/utils/axiosSetting'

export default {
  name: 'Infomation',

  props: {
    item: Object,
    heading: {
      type: String,
      default: 'お知らせ'
    },
    simple: {
      type: Boolean,
      default: false
    }
  }

  // setup() {
  //   const getInfo = axiosSetting('cms', 'block')
  //   const infoItem = reactive<any>({})

  //   getInfo
  //     .get(
  //       `${process.env.VUE_APP_WPAPI_URL}wp-json/acf/v3/options/options/module_mini_news`
  //     )
  //     .then((res: any) => {
  //       infoItem.text = res.data.module_mini_news.text
  //       infoItem.url = res.data.module_mini_news.url
  //       infoItem.blank = res.data.module_mini_news.blank
  //     })
  // }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.info {
  padding-top: 13px;
  padding-bottom: 13px;
  background-color: #f5f5f5;
  line-height: 1.5;
}

// .info_contents {
//   display: block;
// }

.info_heading {
  margin-bottom: 2px;
  font-weight: 500;
  color: var.$color-red;

  &::before {
    display: inline-block;
    content: '';
    width: 16px;
    height: 16px;
    background: url('~@/assets/images/icon/info.svg') no-repeat;
    background-size: 100% 100%;
    vertical-align: -2px;
    margin-right: 5px;
  }

  .info.-simple & {
    font-size: 1.2rem;

    &::before {
      display: none;
    }
  }
}
</style>
